import { EnergyConsumptionForm } from '@/frontend/components/energy/EnergyConsumptionForm';

export default function EnergyConsumptionNew() {
  return (
    <div className="container py-6">
      <EnergyConsumptionForm />
    </div>
  );
}
